import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import moment from "moment";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { Modal, Spinner } from "reactstrap";
import PlusIcon from "../../../components/Icons/PlusIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import calculateFinancialYears from "../../../utility/CommonFunctions";

export default function CreateTransferAsset() {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);
  const [formPayload, setFormPayload] = useState(null);

  const [pageStates, setPageStates] = useState({
    isLoading: false,
    isLoadingData: location?.state?.data ? true : false,
    assignedSites: [],
    itemsList: [],
    transferAssetDetail: [],
    fromSiteId: "",
    toSiteId: "",
  });

  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  const {
    register,
    setValue,
    getValues,
    reset,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "item",
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({ itemId: "", quantity: "", expenseHeadId: "" });
    }
  }, [fields, append]);

  useEffect(() => {
    getAssignedSites();
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      const locationData = location.state.data;

      let options = { method: "GET" };
      let API =
        apiUrl?.get_transfer_asset_detail +
        `?transferAssetId=${locationData?.id}`;

      callApi(API, options).then((response) => {
        if (response?.status === true) {

          let activeFY = "";
          if (response?.data?.fromSite) {
            const calculatedFY = handleFinancialYearCalculation(response.data.fromSite);
            activeFY = response?.data?.financialYear || calculatedFY;
          }

          GetItemsList(response?.data.fromSite?.id, activeFY);

          const formattedItems = response?.data?.transferassetitems?.map(
            (item) => ({
              itemId: item.itemId,
              quantity: item.quantity,
              expenseHeadId: item.expenseHeadId || "",
            })
          );

          setPageStates((prev) => ({
            ...prev,
            transferAssetDetail: response?.data,
            fromSiteId: response?.data?.fromSite?.id,
            toSiteId: response?.data?.toSite?.id,
          }));

          setTimeout(() => {
            reset({
              fromSiteId: response?.data?.fromSite?.id,
              toSiteId: response?.data?.toSite?.id,
              date: moment(response?.data?.date).format("YYYY-MM-DD"),
              description: response?.data?.description,
              item:
                formattedItems.length > 0
                  ? formattedItems
                  : [{ itemId: "", quantity: "", expenseHeadId: "" }],
            });
            setPageStates((prev) => ({
              ...prev,
              isLoadingData: false,
            }));
          }, 500);
        } else {
          toast.error(response?.message);
          setPageStates((prev) => ({
            ...prev,
            isLoadingData: false,
          }));
        }
      });
    }
  }, []);

  const getAssignedSites = () => {
    const option = { method: "GET" };
    const url = apiUrl?.get_user_site;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          assignedSites: res?.data?.site,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleFinancialYearCalculation = (siteData) => {
    const startDate = siteData?.startDate;
    const endDate = siteData?.endDate;

    let fyStartYear;
    const now = moment();
    const month = now.month() + 1;
    const year = now.year();

    if (!startDate || !endDate) {
      fyStartYear = month >= 4 ? year : year - 1;
      const currentFY = `${fyStartYear}-${fyStartYear + 1}`;
      setFinancialYears([currentFY]);
      setActiveFinancialYear(currentFY);
      return currentFY;
    }

    const fys = calculateFinancialYears(
      moment.utc(startDate).format("YYYY-MM-DD"),
      moment.utc(endDate).format("YYYY-MM-DD")
    );

    setFinancialYears(fys);

    fyStartYear = month >= 4 ? year : year - 1;
    const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

    const selectedFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

    if (location?.state?.data?.financialYear) {
      setActiveFinancialYear(location?.state?.data?.financialYear);
      return location?.state?.data?.financialYear;
    } else {
      setActiveFinancialYear(selectedFY);
      return selectedFY;
    }
  };

  const GetItemsList = (siteId, financialYear) => {
    if (!siteId || !financialYear) return;
    const option = { method: "GET" };
    const url = apiUrl?.get_grn_item + `siteId=${siteId}&financialYear=${financialYear}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          itemsList: res?.data,
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const watchedItems = watch("item") || [];

  const getSelectedItemIds = () => {
    return watchedItems.map((item) => item?.itemId?.toString()).filter(Boolean);
  };

  const onSubmit = (data) => {
    const postData = {
      fromSiteId: data.fromSiteId,
      toSiteId: data.toSiteId,
      date: data.date,
      item: data?.item,
      description: data?.description,
      financialYear: activeFinancialYear,
    };
    setFormPayload(postData);
    setModalOpen(true);
  };

  const handleConfirmSubmit = () => {
    // console.log("submitData=======>", formPayload);
    const isUpdate = location?.state?.data;
    const api = isUpdate
      ? `${apiUrl.update_transfer_asset}?transferAssetId=${location?.state?.data?.id}`
      : apiUrl.create_transfer_asset;

    let options = {
      method: "POST",
      data: formPayload,
    };

    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));

    callApi(api, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setModalOpen(false);

      if (response?.status === true) {
        toast.success(response?.message || "Assets successfully transferred.");
        navigate(-1);
      } else {
        toast.error(response?.message || "Something went wrong.");
      }
    });
  };

  return (
    <>
      {pageStates?.isLoadingData && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-start justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Transfer
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Transfer From<span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-control ${errors?.fromSiteId ? "is-invalid" : ""
                        }`}
                      aria-label="Transfer From"
                      {...register("fromSiteId", {
                        required: "This field is Required",
                      })}
                      value={pageStates?.fromSiteId || ""}
                      onChange={(e) => {
                        const siteId = e.target.value;
                        setPageStates((prev) => ({
                          ...prev,
                          fromSiteId: siteId,
                          toSiteId: "",
                        }));
                        setValue("fromSiteId", siteId);
                        setValue("toSiteId", "");

                        const selectedSite = pageStates.assignedSites.find(s => s.site.id == siteId);
                        let fy = "";
                        if (selectedSite) {
                          fy = handleFinancialYearCalculation(selectedSite.site);
                        }

                        GetItemsList(siteId, fy);
                        reset((prevValues) => ({
                          ...prevValues,
                          item: [
                            {
                              itemId: "",
                              quantity: "",
                              expenseHeadId: "",
                            },
                          ],
                        }));
                      }}
                    //   disabled={location?.state?.data}
                    >
                      <option value="" className="d-none text-muted">
                        Select Site
                      </option>
                      {pageStates?.assignedSites?.length > 0 ? (
                        pageStates?.assignedSites.map((item, index) => (
                          <option key={index} value={item?.site?.id}>
                            {item?.site?.name}
                          </option>
                        ))
                      ) : (
                        <option className="text-muted" value="">
                          No site available
                        </option>
                      )}
                    </select>
                    <ErrorMessage message={errors?.fromSiteId?.message} />
                  </div>
                </div>

                {/* Financial Year of Transfer from site */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year<span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        setActiveFinancialYear(e.target.value)
                        const activeSite = getValues("fromSiteId");
                        GetItemsList(activeSite, e.target.value);
                        reset((prevValues) => ({
                          ...prevValues,
                          item: [
                            {
                              itemId: "",
                              quantity: "",
                              expenseHeadId: "",
                            },
                          ],
                        }));
                      }}
                      disabled={location?.state?.data}
                      value={activeFinancialYear}
                    >
                      {financialYears?.map((fy, index) => (
                        <option key={index} value={fy}>
                          {fy}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>


                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Transfer To<span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-control ${errors?.toSiteId ? "is-invalid" : ""
                        }`}
                      aria-label="Transfer To"
                      {...register("toSiteId", {
                        required: "This field is Required",
                      })}
                      value={pageStates?.toSiteId || ""}
                      onChange={(e) => {
                        const siteId = e.target.value;
                        setPageStates((prev) => ({
                          ...prev,
                          toSiteId: siteId,
                        }));
                        setValue("toSiteId", siteId);
                      }}
                    //   disabled={location?.state?.data}
                    >
                      <option value="" className="d-none text-muted">
                        Select Site
                      </option>
                      {pageStates?.assignedSites?.length > 0 ? (
                        pageStates?.assignedSites.map((item, index) => (
                          <option
                            key={index}
                            value={item?.site?.id}
                            disabled={item?.site?.id === pageStates?.fromSiteId}
                          >
                            {item?.site?.name}
                          </option>
                        ))
                      ) : (
                        <option className="text-muted" value="">
                          No site available
                        </option>
                      )}
                    </select>
                    <ErrorMessage message={errors?.toSiteId?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                    <h4 className="fs-3 rajdhani-semibold my-4 ">
                      Item Details
                    </h4>
                  </div>

                  <table className="table mt-3">
                    <thead>
                      <tr>
                        <th className="text-start">Item</th>
                        <th className="text-start">Quantity</th>
                        <th className="text-start">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((field, index) => (
                        <tr key={field.id}>
                          <td style={{ width: "50rem" }}>
                            <select
                              className={`form-select form-control ${errors?.item?.[index]?.itemId
                                ? "is-invalid"
                                : ""
                                }`}
                              {...register(`item.${index}.itemId`, {
                                required: "Item is required",
                              })}
                              onChange={(e) => {
                                const selectedId = e.target.value;

                                setValue(`item.${index}.itemId`, selectedId);

                                const selectedItem =
                                  pageStates?.itemsList?.find(
                                    (i) => i.item?.id?.toString() === selectedId
                                  );

                                if (selectedItem?.item?.expenseHeadId) {
                                  setValue(
                                    `item.${index}.expenseHeadId`,
                                    selectedItem?.item?.expenseHeadId
                                  );
                                } else {
                                  setValue(`item.${index}.expenseHeadId`, "");
                                }
                              }}
                            >
                              <option value="">Choose Item</option>

                              {pageStates?.itemsList?.length > 0 ? (
                                pageStates?.itemsList?.map((item, index) => {
                                  const selectedItemIds = getSelectedItemIds();
                                  const currentItemId =
                                    watchedItems?.[index]?.itemId?.toString();

                                  const isSelected = selectedItemIds.includes(
                                    item?.item?.id?.toString()
                                  );
                                  const isCurrent =
                                    currentItemId ===
                                    item?.item?.id?.toString();

                                  return (
                                    <option
                                      key={index}
                                      value={item?.item?.id}
                                      disabled={!isCurrent && isSelected}
                                    >
                                      {item?.item?.name}
                                    </option>
                                  );
                                })
                              ) : (
                                <option value="" disabled>
                                  No items found
                                </option>
                              )}
                            </select>
                          </td>

                          <td>
                            <input
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              className={`form-control ${errors?.item?.[index]?.quantity
                                ? "is-invalid"
                                : ""
                                }`}
                              placeholder="Enter Quantity"
                              {...register(`item.${index}.quantity`, {
                                required: "Quantity is required",
                                min: 1,
                              })}
                            />
                          </td>

                          <td>
                            <div className="d-flex gap-2">
                              {fields.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() => remove(index)}
                                >
                                  <DeleteIcon />
                                </button>
                              )}
                              {index === fields.length - 1 && (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() => {
                                    // const siteId = watch("siteId");
                                    if (!pageStates.fromSiteId) {
                                      toast.warning(
                                        "Please select a site first."
                                      );
                                      return;
                                    }

                                    if (pageStates?.itemsList?.length === 0) {
                                      toast.info(
                                        "No items available for the selected site."
                                      );
                                      return;
                                    }

                                    const selectedItemIds =
                                      getSelectedItemIds();
                                    const allItemIds =
                                      pageStates?.itemsList?.map((i) =>
                                        i.itemId?.toString()
                                      ) || [];

                                    const unselectedItems = allItemIds.filter(
                                      (id) => !selectedItemIds.includes(id)
                                    );

                                    if (unselectedItems.length === 0) {
                                      toast.info("No more items to select.");
                                      return;
                                    }

                                    append({
                                      itemId: "",
                                      quantity: "",
                                      expenseHeadId: "",
                                    });
                                  }}
                                >
                                  <PlusIcon />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="col-12 col-md-6 col-lg-12">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={pageStates?.isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {location?.state?.data ? "Update" : "Transfer"}
                </button>
              </div>
            </div>
          </div>
        </form>
        <Modal className="modal-dialog modal-dialog-centered modal-md" isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
          <div className="modal-header border-0">
            <div className="d-flex align-items-center">
              <i className="bi bi-exclamation-triangle-fill text-warning fs-3 me-2"></i>
              <h5 className="modal-title mb-0">Confirm Transfer</h5>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={() => setModalOpen(false)}
            />
          </div>

          <div className="modal-body text-center py-5">
            <p className="mb-3">
              Are you sure you want to{" "}
              <strong>{location?.state?.data ? "update" : "create"}</strong>{" "}
              this transfer?
            </p>
          </div>

          <div className="modal-footer border-0 justify-content-center mb-5">
            <button
              type="button"
              className="btn btn-outline-secondary px-5"
              onClick={() => setModalOpen(false)}
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-primary px-5"
              onClick={handleConfirmSubmit}
              disabled={pageStates?.isLoading}
            >
              {pageStates?.isLoading ? <Spinner /> : <>Yes</>}
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
}
